
export const API = process.env.REACT_APP_BACKEND_URL!
// export const API = "http://localhost:3000"
// export const API = "http://10.133.7.188:3030"
export const S3IMG = process.env.S3_ENDPOINT!
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY!

// ===================== NAVIGATION ==================== // 
export const Navigation = {
    DASHBOARD: "/dashboard",
    BILL: "/buchhaltung/rechnungen/",
    BILL_DETAILED: "/buchhaltung/rechnung/",
    BILL_ADD: "/buchhaltung/rechnungen",
    BILL_TEMPLATE: "/buchhaltung/rechnungsvorlagen/",
    OFFER: "/buchhaltung/angebote/",
    OFFER_ADD: "/buchhaltung/angebote",
    MAJOR_ORDER: "/buchhaltung/aufträge/",
    PAY_REQ: "/buchhaltung/zahlungen/",
    TRANSACTIONS: "/buchhaltung/transaktionen/",
    CALENDAR: "/kalender/",
    TOURS: "/touren/",
    ORDER_REQUEST_ACTION_CODE: "/buchhaltung/aufträge/aktionen/",
    SESSION: "/termin/",
    TASKS: "/aufgaben/",
    TASK_TEMPLATES: "/aufgaben-wiederkehrend/",
    OBJECTS: "/objekte/",
    CUSTOMER: "/kunden/",
    EMPLOYEE: "/mitarbeiter/",
    ORDER_REQUESTS: "/anfragen/",
    MAP: "/karte",
    HELP: "/hilfe",
    ERROR: "/404",
    ABSENCE: "/abwesenheiten/",
    OVERVIEW: "/overview",
    ADD_REPORT: "/aufgaben/bericht-erstellen",
    REPORTS: "/berichte/",
    COMING_SOON: "/coming-soon",
    KEYS: "/schluessel",
}

// ===================== QUERY KEYS ==================== // 
export const GeneralQueryKeys = {
    CREDIT_DATA: "creditData",
    KEYS_ALL: "keys",
    OFFER_DATA: "offerData",
    OFFER_SINGLE: "singleOffer",
    OFFER_BY_OBJECT: "offerByObject",
    PAYREQS_ALL: "paymentRequirements",
    PAYMENT_REQUIREMENTS_SINGLE_BILL: "paymentRequirementsSingleBill",
    OBJECTS_ALL: "objectData",
    OBJECTS_ADDRESS_ONLY: "objectAddresses",
    OBJECT_SINGLE: "singleObjectData",
    OBJECT_SINGLE_IMAGE: "singleObjectImage",
    OBJECT_STATISTICS: "objectStatistics",
    TRANSACTIONS_ALL: "transactions",
    TRANSACTIONS_ASSIGNED: "assignedTransactionData",
    MAJOR_ORDER_ALL: "majorOrder",
    MAJOR_ORDER_SINGLE: "majorOrderSingle",
    CUSTOMER_ALL: "customer",
    CUSTOMER_SINGLE: "singleCustomerData",
    CUSTOMER_NAMES_ONLY: "customerNamesOnly",
    CUSTOMER_OBJECT_DATA: "customerObjectData",
    ADMINISTRATOR_ALL: "administrator",
    COSTCENTER_ALL: "costcenter",
    COSTCENTER_NAMES: "costcenterNames",
    TIMETRACKING: "timetracking",
    EMPLOYEE_ALL: "employee",
    EMPLOYEE_SINGLE: "singleEmployeeData",
    EMPLOYEE_SESSION: "employeeSessions",
    EMPLOYEE_NAMES_ONLY: "employeeNamesOnly",
    ABSENCE: "absence",
    ORDER_REQUEST: "orderRequest",
    TASK: "task",
    TASK_TEMPLATE: "taskTemplate",
    SESSION_SINGLE: "Session",
    TOURS: "tours",
    TOUR_SINGLE: "singleTour",
    REPORT: "report",
    REPORT_SINGLE: "singleReport",
    BILL_DATA: "billData",
    BILL_SINGLE: "singleBill",
    BILL_BY_OBJECT: "billByObject",
    BILL_TEMPLATE_ALL: "billTemplate",
    BILL_TEMPLATE_SINGLE: "singleBillTemplate",
    FINANCE_STATISTICS: "financeStatistics",
    EMPLOYEE_STATISTICS: "employeeStatistics",
    CUSTOMER_STATISTICS: "customerStatistics",
    KC_USER_GROUPS: "kcUserGroups",
    COMPANY_DATA: "companyData",
    COMPANY_DATA_LOGO: "companyDataLogo",

}

// ======================= FILTER ====================== // 
export const LocalStorageKeys = {
    CREDIT_FILTER: "creditFilter",
    BILL_FILTER: "billFilter",
    BILL_TEMPLATE_FILTER: "billTemplateFilter",
    PAYREQ_FILTER: "payreqFilter",
    TRANSACTION_FILTER: "transactionFilter",
    CUSTOMER_FILTER: "customerFilter",
    EMPLOYEE_FILTER: "employeeFilter",
    ORDER_REQUEST_FILTER: "orderRequestFilter",
    MAJOR_ORDER_FILTER: "majorOrderFilter",
    TASK_FILTER: "taskFilter",
    TASK_TEMPLATE_FILTER: "taskTemplateFilter",
    REPORT_FILTER: "reportFilter",
    OBJECT_FILTER: "objectFilter",
    ABSENCE_FILTER: "absenceFilter",
    OFFER_FILTER: "offerFilter",
    KEY_FILTER: "keyFilter",
}


// ======================== BILL ======================= // 
export const BillTypes = {
    RECHNUNG: "Rechnung",
    DAUER_RECHNUNG: "Dauerrechnung",
    JAHRES_RECHNUNG: "Jahresrechnung",
    ABSCHLAGS_RECHNUNG: "Abschlagsrechnung",
    SCHLUSS_RECHNUNG: "Schlussrechnung",
}

export const BillCategorie = {
    HAUSMEISTER: "Hausmeister",
    SCHLUESSELDIENST: "Schlüsseldienst",
    BAU: "Bau",
    VERMIETUNG: "Vermietung",
    SONSTIGES: "Sonstiges",
}

// Einheiten der Rechnungspositionen - der Python Service ordnet sie dem E-Rechnungs-Code (BT-130) zu (service/xml_filework.py: UNIT_CODES)
export const PositionUnits = ["Stück", "Pauschale", "Stunde", "Tag", "Woche", "Monat", "Jahr", "m", "m²", "m³", "kg", "t", "Liter", "km"]

// ================ PAYMENT REQUIREMENtS =============== //



// ================ CALENDAR ROUTE OPTIMIZATION =============== //
export const CalendarRouteOptimization = {
    MONDAY: "monday",
    TUESDAY: "tuesday",
    WEDNESDAY: "wednesday",
    THURSDAY: "thursday",
    FRIDAY: "friday",
}

// ====================== ABSENCE ===================== //

export const AbsencesTypes = {
    SICK: "Krankheit",
    VACATION: "Urlaub",
}

// ==================== MAJOR ORDER ==================== // 

export const MajorOrderState = {
    UNBILLED: 'unbilled',
    PARTIALLY_BILLED: 'partially_billed',
    FULLY_BILLED: 'fully_billed',
}

export const MajorOrderActionCode = {
    CREATED: 'Auftrag erstellt',
    EDIT: ' Bearbeitet',
    CANCELED: 'Storniert',
    BILLED: 'Abschlagsrechnung ausgestellt',
    FINAL_BILLED: 'Schlussrechnung ausgestellt',
}